import React from 'react';
import {  Link, Preloader } from 'MWC';
import Calculator from '../../../auxiliary-components/Calculator';
import '../less/main.less';
import clearBR from '../../../helpers/utils/clearBR';
import Hint from '../views/hint.c';
import Breadcrumbs from '../../../auxiliary-components/Breadcrumbs';
import { MAIN, CREDIT, SALARY } from '../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import {LANG} from '../../../services/l10n';
import TextAboveFooter from '../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c';
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';

export default function template() {
    const model = this.getModel(),
        isMobile = this.isViewportMobile(),
        pathToEssentialCharacteristicsFolder = '/static/essential_characteristics',
        moneyTillSalaryFile = this.props.lang === LANG.UA ?
        "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/GDZ/Istot_GDZ_ua.pdf" :
        "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/GDZ/Istot_GDZ_ru.pdf",
        salaryTariffs = this.props.lang === LANG.UA ?
            "https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/GDZ_ua.pdf" :
            "https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/GDZ_ru.pdf",
        creditDescriptionOne = isMobile ? clearBR(this.l10n("CREDIT_SALARY_DESC_1")) : this.l10n("CREDIT_SALARY_DESC_1"),
        creditDescriptionTwo = isMobile ? clearBR(this.l10n("CREDIT_SALARY_DESC_2")) : this.l10n("CREDIT_SALARY_DESC_2"),
        links = [MAIN, CREDIT, SALARY];

    return !model.creditSum ?
        (<div className="preload-wrapper">
            <Preloader />
        </div>)
        : (
            <div className="credit-calculator salary">
                <Breadcrumbs links={links} {...this.props} />
                <div className="banner">
                    <div className="banner-content">
                        <div className="banner-title">{this.l10n('CREDIT_SALARY_BANNER_TITLE')}</div>
                        <div className="banner-message">{this.l10n('CREDIT_SALARY_BANNER_SUBTITLE')}</div>
                        <Link href={`/credit`} onClick={e => this.context.app.navigate(`/credit`, e)}>
                            <div className="backward-btn">{this.l10n('CREDIT_NEW_INSTALLMENT_BANNER_BACKWARD')}</div>
                        </Link>
                    </div>
                </div>
                <div className="content">
                    <div className="credit-description">
                        <p className="credit-description-title block-title">{this.l10n('CREDIT_SALARY_WHAT_IS')}</p>
                        <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: creditDescriptionOne }} />
                        <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: creditDescriptionTwo }} />
                    </div>
                    <div className="credit-offer salary-offer">
                        <p className="block-title">{this.l10n('CREDIT_NEW_INSTALLMENT_OFFER')}</p>
                        <div className="credit-offer-body">
                            <div className="credit-offer-body-item">
                                <p className="item-title block-title">
                                    {this.l10n('CREDIT_SALARY_OFFER_TITLE_1')}
                                    <span className="upper">{this.l10n('CREDIT_SALARY_UAH')}</span>
                                </p>
                                <p className="item-description">
                                    {this.l10n('CREDIT_SALARY_OFFER_TEXT_1')}
                                </p>
                            </div>
                            <div className="credit-offer-body-item">
                                <p className="item-title block-title">
                                    {this.l10n('CREDIT_SALARY_OFFER_TITLE_2')}
                                    <span className="upper">{this.l10n('CREDIT_SALARY_MONTHS')}</span>
                                </p>
                                <p className="item-description">
                                    {this.l10n('CREDIT_SALARY_OFFER_TEXT_2')}
                                </p>
                            </div>
                            <div className="credit-offer-body-item">
                                <p className="item-title block-title">
                                    {this.l10n('CREDIT_SALARY_OFFER_TITLE_3')}
                                </p>
                                <p className="item-description">
                                    {this.l10n('CREDIT_SALARY_OFFER_TEXT_3')}
                                </p>
                            </div>
                            <div className="credit-offer-body-item">
                                <p className="item-title block-title">
                                    {this.l10n('CREDIT_SALARY_OFFER_TITLE_4')}
                                </p>
                                <p className="item-description">
                                    {this.l10n('CREDIT_SALARY_OFFER_TEXT_4')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="credit-calculator">
                        <p className="block-title">{this.l10n('CREDIT_INSTALLMENT_CALC')}</p>
                        <div className="calculator-wrapper">
                            <Calculator model={this.getModel()} type={this.state.selectedType} {...this.props} />
                        </div>
                    </div>
                    <div className="credit-instruction">
                        <p className="block-title">{this.l10n('CREDIT_SALARY_INSTRUCTION_TITLE')}</p>
                        <div className="credit-instruction-body">
                            <div className="line" />
                            <div className="credit-instruction-body-item">
                                <div className="item-figure one"></div>
                                <p className="item-title centered">{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_1_TITLE')}</p>
                                <p className="item-description" dangerouslySetInnerHTML={{ __html: this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_1_TEXT') }} />
                                <div className="dot" />
                                <div className="bullet" />
                            </div>
                            <div className="credit-instruction-body-item">
                                <div className="item-figure two"></div>
                                <p className="item-title centered">{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_2_TITLE')}</p>
                                <p className="item-description">{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_2_TEXT')}</p>
                                <div className="dot" />
                                <div className="bullet" />
                            </div>
                            <div className="credit-instruction-body-item">
                                <div className="item-figure three"></div>
                                <div className="item-title centered">{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_3_TITLE')}</div>
                                <div className="item-description">{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_3_TEXT')}
                                    <Hint {...this.props}>
                                        <span>{this.l10n('CREDIT_SALARY_INSTRUCTION_ITEM_3_HINT')}</span>
                                    </Hint>
                                </div>
                                <div className="dot" />
                                <div className="bullet" />
                            </div>
                        </div>
                    </div>
                    <div className="credit-payment">
                        <p className="block-title">{this.l10n('CREDIT_SALARY_TITLE')}</p>
                        <div className="credit-payment-body">
                            <div className="credit-payment-body-item">
                                <div className="item-img columns"></div>
                                <div className="item-text">{this.l10n('CREDIT_SALARY_STEP_1')}</div>
                            </div>
                            <div className="credit-payment-body-item">
                                <div className="item-img phone"></div>
                                <div className="item-text">{this.l10n('CREDIT_SALARY_STEP_2')}</div>
                            </div>
                            <div className="credit-payment-body-item">
                                <div className="item-img bank"></div>
                                <div className="item-text">{this.l10n('CREDIT_SALARY_STEP_3')}</div>
                            </div>
                        </div>
                    </div>

                    <FilesForDownload page={'reports'} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>

                    <div className="disclaimer-wrapper">
                        <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}/>
                    </div>
                </div>
            </div>
        );
}
